import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslationService } from '../../../services/translation/translation.service';
import { ModalAction } from '../../../models/modalAction.model';

@Component({
  selector: 'app-multi-action-modal',
  templateUrl: './multi-action-modal.component.html',
  styleUrl: './multi-action-modal.component.css'
})
export class MultiActionModalComponent {
  title: string = "";
  message: string = "";
  actions: ModalAction[] = [];

  constructor(private dialogRef: MatDialogRef<MultiActionModalComponent>,
    private translationService: TranslationService,
    @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string, actions: ModalAction[] }) {
      this.title = this.data.title;
      this.message = this.data.message;
      this.actions = this.data.actions;
  }

  onAction(action: string): void {
    this.dialogRef.close(action);
  }
}
